import gql from 'graphql-tag'

export const WATER_TESTING_MAP_PINS_QUERY = gql`
  query waterTestingMapPins($accountId: Int!) {
    waterTestingMapPins(accountId: $accountId) {
      lat
      lng
      facilityId
    }
  }
`
